<template>
  <div>
    <filter-search
      @search="search"
      exportTemplate="BoardManage"
      filename='经营分析'
    />
    <business-table :tableData="tableData" />
  </div>
</template>
<script>
import filterSearch from '../FilterSearch.vue'
import businessTable from './businessTable/index.vue'
import { postStatManage } from '@/api/domain/workbench'
import moment from 'moment'

export default {
  components: {
    filterSearch,
    businessTable,
  },
  data() {
    return {
      formData: {
        searchDate: moment().format('YYYY-MM-DD') || '',
      },
      tableData: [],
    }
  },
  methods: {
    search(val, cb) {
      this.formData.searchDate = val.searchDate
      this.postStatManage().then(() => {
        cb()
      })
    },
    async postStatManage() {
      const params = {
        searchType: 1,
        searchDate: this.formData.searchDate,
      }
      const { data } = await postStatManage(params)
      this.tableData = data || []
      return this.tableData
    },
  },
}
</script>
